import React, { Component } from "react";
import "./MultiSelectDropdown.css";

class MultiSelectDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVehicles: props.selectedVehicles || [],
    };
  }

  toggleVehicle = (vehicle) => {
    this.setState((prevState) => {
      const selected = prevState.selectedVehicles.some(
        (v) => v.id === vehicle.id
      )
        ? prevState.selectedVehicles.filter((v) => v.id !== vehicle.id)
        : [...prevState.selectedVehicles, vehicle];
        // console.log("selected",selected)
      return { selectedVehicles: selected };
    });
  };

  selectAll = () => {
    this.setState({ selectedVehicles: [...this.props.vehicleList] });
  };

  clearAll = () => {
    this.setState({ selectedVehicles: [] });
  };

  addSelected = () => {
    this.props.onSelect(this.state.selectedVehicles);
  };

  render() {
    const { vehicleList, onClose, searchQuery } = this.props;
    const { selectedVehicles } = this.state;

    const filteredList = vehicleList.filter((vehicle) =>
      vehicle.vehicleno.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
      <div className="multi-select-dropdown">
        <div className="header">
          <span onClick={this.selectAll}>Select All</span>
          <span onClick={this.clearAll}>Clear All</span>
        </div>

        <div className="vehicle-list">
          {filteredList.map((vehicle) => (
            <label key={vehicle.id} className="vehicle-item">
              <input
                type="checkbox"
                checked={selectedVehicles.some((v) => v.id === vehicle.id)}
                onChange={() => this.toggleVehicle(vehicle)}
              />
              <span>{vehicle.vehicleno}</span>
            </label>
          ))}
        </div>

        <div className="footer">
          <button className="footer-cancel" onClick={onClose}>Cancel</button>
          <button className="footer-add" onClick={this.addSelected}>Add</button>
        </div>
      </div>
    );
  }
}

export default MultiSelectDropdown;
